var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRating = function SvgRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "rating_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#rating_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M4.722 13.91a.42.42 0 0 1-.5.012q-.25-.16-.15-.456L5.193 9.78a.5.5 0 0 0-.187-.552l-2.81-2.015q-.276-.198-.163-.482.112-.284.387-.284h3.534a.5.5 0 0 0 .478-.353L7.6 2.297A.415.415 0 0 1 8 2q.125 0 .238.074.112.075.162.223l1.168 3.798a.5.5 0 0 0 .478.353h3.534q.274 0 .387.284t-.162.482l-2.811 2.015a.5.5 0 0 0-.187.552l1.121 3.685q.1.296-.15.456a.42.42 0 0 1-.5-.012l-2.979-2.223a.5.5 0 0 0-.598 0zm.96-2.166a.1.1 0 0 0 .157.108l1.86-1.398a.5.5 0 0 1 .601 0l1.861 1.398a.1.1 0 0 0 .157-.108l-.692-2.362a.5.5 0 0 1 .187-.546l1.69-1.219a.1.1 0 0 0-.06-.18H9.32a.5.5 0 0 1-.477-.353L8.096 4.68a.1.1 0 0 0-.192 0l-.746 2.404a.5.5 0 0 1-.477.352H4.556a.1.1 0 0 0-.058.181l1.689 1.219a.5.5 0 0 1 .187.546z"
  }))));
};
export default SvgRating;